import React from 'react';
import work from '../../assets/work.svg';
import study from '../../assets/study.svg';
import styles from './styles.module.scss';

function CareerItem(props) {
	return (
		<div className={styles.careerItemContainer}>
			<div className={styles.iconContainer}>
				{props.type === 'exp' ? (
					<img src={work} alt='work svg' />
				) : (
					<img src={study} alt='work svg' />
				)}
			</div>

			<div className={styles.textContainer}>
				<h3>{props.title}</h3>
				{props.info ? <h6 className={styles.info}>{props.info}</h6> : null}
				<h6>{props.date}</h6>
			</div>
		</div>
	);
}

export default CareerItem;
